import { navigateRef } from "router/routes";
import { showToast, signOut } from "./helper";

export function handleError(error) {
  if (error?.response?.status === 403) {
    showToast(
      "Desculpe, você não tem permissão para executar esta ação.",
      "error"
    );
    navigateRef.current("/", { replace: true });
  }
  if (error?.response?.status === 401) {
    showToast("Parece que sua sessão expirou, faça login novamente.", "error");
    signOut().then(() => {
      navigateRef.current("/login", { replace: true });
    });
  }
}
